import { IS_PROD } from '@muzly/shared';

import { appIdentity } from './linkRoute';

import type { DevicePlatform } from './openInApp';

// App Store Connect 의 Apple ID — 운영 앱(`io.muzly.app`) 하나뿐이다.
const APP_STORE_ID = '6813373514';

/**
 * 이 기기에서 앱을 받는 스토어 주소. 데스크톱과 운영이 아닌 빌드는 `null` 이다 —
 * 스토어에 올라간 것은 운영 앱뿐이라, 개발 웹에서 보내면 개발 앱과 다른 앱을 깔게 된다.
 */
export const storeUrlOf = (
  platform: DevicePlatform,
  isProd: boolean = IS_PROD,
): string | null => {
  if (!isProd || platform === 'desktop') {
    return null;
  }
  return platform === 'ios'
    ? `https://apps.apple.com/app/id${APP_STORE_ID}`
    : `https://play.google.com/store/apps/details?id=${appIdentity(true).androidPackage}`;
};
